// extracted by mini-css-extract-plugin
export default {"root":"root-C4HJui","empty":"empty-ruv5Ay"};